// Chakra imports
import { Portal, Box, useDisclosure, Text, Button, Link } from '@chakra-ui/react';
import Footer from 'components/footer/FooterAdmin.js';
// Layout components
import Navbar from 'components/navbar/NavbarAdmin.js';
import Sidebar from 'components/sidebar/Sidebar.js';
import { SidebarContext } from 'contexts/SidebarContext';
import React, { useState, useEffect } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import routesRaw from 'routes.js';
import ApiService from "services/api.js";
// Custom Chakra theme
export default function Dashboard(props) {
	let rawList = JSON.parse(localStorage.getItem('verified_user'))
	let menuList = rawList ? rawList.roleMenu : null
	let routes = {}

	if (menuList != null) {
		routes = routesRaw
			.filter(item => menuList.some(menuItem => menuItem.menu_name === item.name));
	} else {
		routes = routesRaw
	}
	const isAuthenticated = true;
	const history = useHistory()
	const { ...rest } = props;
	// states and functions
	const [fixed] = useState(false);
	const [toggleSidebar, setToggleSidebar] = useState(false);
	// functions for changing the states from components
	const getRoute = () => {
		return window.location.pathname !== '/admin/full-screen-maps';
	};
	const getActiveRoute = (routes) => {
		let activeRoute = 'Default Brand Text';
		for (let i = 0; i < routes.length; i++) {
			if (routes[i].collapse) {
				let collapseActiveRoute = getActiveRoute(routes[i].items);
				if (collapseActiveRoute !== activeRoute) {
					return collapseActiveRoute;
				}
			} else if (routes[i].category) {
				let categoryActiveRoute = getActiveRoute(routes[i].items);
				if (categoryActiveRoute !== activeRoute) {
					return categoryActiveRoute;
				}
			} else {
				if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
					return routes[i].name;
				}
			}
		}
		return activeRoute;
	};
	const getActiveNavbar = (routes) => {
		let activeNavbar = false;
		for (let i = 0; i < routes.length; i++) {
			if (routes[i].collapse) {
				let collapseActiveNavbar = getActiveNavbar(routes[i].items);
				if (collapseActiveNavbar !== activeNavbar) {
					return collapseActiveNavbar;
				}
			} else if (routes[i].category) {
				let categoryActiveNavbar = getActiveNavbar(routes[i].items);
				if (categoryActiveNavbar !== activeNavbar) {
					return categoryActiveNavbar;
				}
			} else {
				if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
					return routes[i].secondary;
				}
			}
		}
		return activeNavbar;
	};
	const getActiveNavbarText = (routes) => {
		let activeNavbar = false;
		for (let i = 0; i < routes.length; i++) {
			if (routes[i].collapse) {
				let collapseActiveNavbar = getActiveNavbarText(routes[i].items);
				if (collapseActiveNavbar !== activeNavbar) {
					return collapseActiveNavbar;
				}
			} else if (routes[i].category) {
				let categoryActiveNavbar = getActiveNavbarText(routes[i].items);
				if (categoryActiveNavbar !== activeNavbar) {
					return categoryActiveNavbar;
				}
			} else {
				if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
					return routes[i].messageNavbar;
				}
			}
		}
		return activeNavbar;
	};
	const PrivateRoute = (props) => {
		let userId = false;
		let getToken = JSON.parse(localStorage.getItem("user"))
		if (getToken !== null) {
			userId = true
		}

		// console.log("hit ini jika true pri", props)
		return userId ? (
			<Route path={props.path} component={props.component} />
		) : (
			<Redirect to="/auth/sign-in" />
		);
	};

	const getRoutes = (routes) => {
	// console.log("ini rout", routes)
		return routes.map((prop, key) => {

			if (prop.layout === '/admin') {
			// console.log("info auth", prop.name)
				if (prop.AuthRequired === true) {
				// console.log("hit ini jika true", prop.AuthRequired)
					return <PrivateRoute path={prop.layout + prop.path} component={prop.component} key={key} />;
				} else {
					return <Route path={prop.layout + prop.path} component={prop.component} key={key} />;
				}

			}
			if (prop.collapse) {
				return getRoutes(prop.items);
			}
			if (prop.category) {
				return getRoutes(prop.items);
			} else {
				return null
			}
		});
	};
	document.documentElement.dir = 'ltr';
	const { onOpen } = useDisclosure();
	document.documentElement.dir = 'ltr';

	let dataMenuUser = ApiService.firstMenu();
	let filteredDataMenu = routes.filter(({ name }) => name === dataMenuUser);
	let url = "";

	if (filteredDataMenu.length > 0) {
		url = filteredDataMenu[0].layout + filteredDataMenu[0].path;
	} else {
		url = "/admin/dashboard";
	}

	async function checkRoleUpdates() {
		try {
			
		  // Get the current user data
		  const userData = JSON.parse(localStorage.getItem("verified_user")) || {};

		  const roleId = userData.role_id; // Adjust based on your actual data structure
		  
		  if (!roleId) return; // Exit if no role ID is found
		  
		  // Call your API endpoint to check for updates
		  const response = await ApiService.client.get(
			`/auth/getRolesByID/${roleId}`,
			await ApiService.options()
		  );

		  // console.log("Response ni", response.data.data)

		  // Remove all items that are in the selected list and add the fresh data
		  const updatedUserData = {
			email: userData.email,
			token: userData.token,
			roleBranch: [], // This will be populated with fresh data
			roleMenu: [],    // This will be populated with fresh data
			role_id: userData.role_id
		  };
	
		  // Add the new items

		  updatedUserData.roleBranch = response.data.data[0].RolePermissionBranch;
	
		  // Add the new items
		  updatedUserData.roleMenu = response.data.data[0].RolePermissionMenu;
	
		  // remove old verified user
		  localStorage.removeItem("verified_user");
	
		  // add new verified user
		  localStorage.setItem("verified_user", JSON.stringify(updatedUserData));
		  
		//   // If role has been updated
		//   if (response.data.updated) {
		// 	// Update localStorage with new permissions/role data
		// 	const updatedUserData = {
		// 	  ...userData,
		// 	  role: response.data.role_name,
		// 	  permissions: response.data.permissions,
		// 	  branch_ids: response.data.branch_ids,
		// 	  menu_ids: response.data.menu_ids
		// 	  // Add any other fields that might have changed
		// 	};
			
		// 	localStorage.setItem('userData', JSON.stringify(updatedUserData));
			
			// If you're using a state management solution like Redux or Context
			// Update your application state
			// Example: dispatch(updateUserRole(response.data));
			
			// Optionally notify the user
			//notifyUser("Your permissions have been updated");
			
			// Refresh relevant components or views
			//refreshUserInterface();
		  //}
		} catch (error) {
		  console.error("Failed to check for role updates:", error);
		}
	  }

	  function setupPeriodicRoleCheck() {
		// Check every 5 minutes (adjust timing as needed)
		const checkInterval = 10 * 1000;
		// console.log("TESSSSSSSS")
		
		// Initial check
		checkRoleUpdates();
		
		// Setup periodic checks
		const intervalId = setInterval(checkRoleUpdates, checkInterval);
		
		// Store the interval ID so it can be cleared when needed
		localStorage.setItem('roleCheckIntervalId', intervalId);
		
		// Clean up on logout or when component unmounts
		return () => clearInterval(intervalId);
	  }

	// In your App.js or a similar root component
useEffect(() => {
	const cleanup = setupPeriodicRoleCheck();
	
	// Clean up when component unmounts
	return cleanup;
  }, []);

	return (
		<Box>
			<Box>
				<SidebarContext.Provider
					value={{
						toggleSidebar,
						setToggleSidebar
					}}>
					<Sidebar routes={routes} display='none' {...rest} />
					<Box
						float='right'
						minHeight='100vh'
						height='100%'
						overflow='auto'
						position='relative'
						maxHeight='100%'
						w={{ base: '100%', xl: 'calc( 100% - 290px )' }}
						maxWidth={{ base: '100%', xl: 'calc( 100% - 290px )' }}
						transition='all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)'
						transitionDuration='.2s, .2s, .35s'
						transitionProperty='top, bottom, width'
						transitionTimingFunction='linear, linear, ease'>
						<Portal>
							<Box>
								<Navbar
									onOpen={onOpen}
									logoText={'Tuku Dashboard'}
									brandText={getActiveRoute(routes)}
									secondary={getActiveNavbar(routes)}
									message={getActiveNavbarText(routes)}
									fixed={fixed}
									{...rest}
								/>
							</Box>
						</Portal>

						{getRoute() ? (
							<Box mx='auto' p={{ base: '20px', md: '30px' }} pe='20px' minH='100vh' pt='50px'>
								<Switch>
									{getRoutes(routes)}

									<Redirect from='/' to={url} />
								</Switch>
							</Box>
						) : null}
						<Box>
							<Footer />
						</Box>
					</Box>
				</SidebarContext.Provider>
			</Box>
		</Box>
	);
}
